import React, { useState, useEffect } from "react";
import { Link, useLocation, useParams, useNavigate } from "react-router-dom";
import { Button, Form, Card } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleLeft } from "@fortawesome/free-solid-svg-icons";
import useFetch from "../../../hooks/useFetch";
import Swal from "sweetalert2";
import Select from 'react-select';

// https://dev.to/bytebodger/constructors-in-functional-components-with-hooks-280m
// https://reactjs.org/docs/hooks-state.html
// https://beta.reactjs.org/reference/react/useRef
// https://ui.dev/react-router-pass-props-to-link

export default function Inventario() {
    const navigate = useNavigate();
    const { get, post, put } = useFetch();
    const defaultState = {
        acao: "Visualizar",
        inventario: { sec_inventario: "", data_inventario: "", observacao: "" },
        opcoesUsuario: [],
        opcoesItem: [],
        usuarioSelecionado: [],
        itemSelecionado: [],
        idItemAntigo: [],
    }

    /* objeto recebido do state={} do <Link> da página anterior
    ** https://v5.reactrouter.com/web/api/location  https://v5.reactrouter.com/web/api/Hooks/uselocation */
    let location = useLocation();

    // https://v5.reactrouter.com/web/example/url-params
    let { id,sec } = useParams();

    useEffect(() => {
        const fetchData = async () => {
            let inventario = defaultState.inventario;
            let usuarioSelecionado = defaultState.usuarioSelecionado;
            let itemSelecionado = defaultState.itemSelecionado;
            if (id === "criar" && sec === "inventario") {
                setState({ ...state, acao: "Criar" });
            }
            else {
                inventario = await buscarInventario(id,sec);
                if(!inventario.Usuario) {
                    usuarioSelecionado = defaultState.usuarioSelecionado;
                } else {
                    usuarioSelecionado = {value: inventario.Usuario.id_usuario, label: inventario.Usuario.nome_pessoa};
                }

                if(!inventario.Item) {
                    itemSelecionado = defaultState.itemSelecionado;
                } else {
                    itemSelecionado = {value: inventario.Item.id_item, label: inventario.Item.nome_item};
                }
            }
    
            let opcoesItem = await buscarItens({});
            let opcoesUsuario = await buscarUsuarios({});
            setState({
                ...state,
                inventario: inventario,
                opcoesUsuario: opcoesUsuario,
                opcoesItem: opcoesItem,
                itemSelecionado: itemSelecionado,
                usuarioSelecionado: usuarioSelecionado,
            });
        }
        fetchData();
    }, [id,sec])


    /* https://reactjs.org/docs/hooks-reference.html#lazy-initial-state
    ** define o state inicial do componente, o useState retorna um array com 2 elementos, 
    ** objeto state e função setState pra atualizar o objeto state */
    const [state, setState] = useState(() => {
        // se a página anterior passou um state, retorna ele
        if (location.state) {
            if (location.state.acao) {
                defaultState.acao = location.state.acao;
            }
        }
        // senão, retorna um objeto vazio
        return defaultState;
    });

    async function buscarInventario(id_item, sec_inventario) {
        try {
            let response = await get("/inventario/" + id_item + '/' + sec_inventario);
            if (response.status === 200) {
                let dados = response.result.data;
                if (!dados || Object.keys(dados).length === 0)
                    return defaultState.inventario;
                return dados;
            } else {
                return defaultState.inventario;
            }
        } catch (error) {
            console.error("Erro no buscarInventario():", error);
            return defaultState.inventario;
        }
    }

    async function buscarUsuarios(filtros) {
        let query = "?";
        if (filtros && Object.keys(filtros).length > 0) {
            for (const key in filtros) {
                if (filtros[key] !== "") {
                    query = query.concat(key, "=", filtros[key], "&");
                }
            }
        }
        try {
            let response = await get("/usuario" + query);
            if (response.status === 200) {
                let dados = response.result.data;
                let opcoesUsuario = dados.map(usuario => ({
                    value: usuario.id_usuario,
                    label: usuario.nome_pessoa
                }));
                return opcoesUsuario;
            } else {
                return [];
            }
        } catch (error) {
            console.error('Erro no buscarUsuarios():', error);
        }
    }

    async function buscarItens(filtros) {
        let query = "?";
        if (filtros && Object.keys(filtros).length > 0) {
            for (const key in filtros) {
                if (filtros[key] !== "") {
                    query = query.concat(key, "=", filtros[key], "&");
                }
            }
        }
        try {
            let response = await get("/item" + query);
            if (response.status === 200) {
                let dados = response.result.data;
                let opcoesItem = dados.map(item => ({
                    value: item.id_item,
                    label: item.nome_item
                }));
                return opcoesItem;
            } else {
                return [];
            }
        } catch (error) {
            console.error('Erro no buscarItens():', error);
        }
    }

    function changeInventario(event) {
        let name = event.target.name; // name do campo que disparou o evento
        let value = event.target.value; // value do campo   

        // ex: se o campo com name Nome for alterado, atualiza o objeto state com o novo valor do campo Nome
        // { Nome: "novo valor do campo Nome" }
        setState(prevState => ({
            ...prevState,
            inventario: {
                ...prevState.inventario,
                [name]: value
            }
        }));
    }

    function changeItem(data){
        state.idItemAntigo = state.itemSelecionado.value;
        state.itemSelecionado = data;
        setState({...state, itemSelecionado: data});
    }

    function changeUsuario(data){
        state.usuarioSelecionado = data;
        setState({...state, usuarioSelecionado: data});
    }

    async function salvarInventario() {
        let method = state.acao === "Criar" ? post : put;
        try {
            let id_usuario = state.usuarioSelecionado.value;
            let id_item = state.itemSelecionado.value;
            let body = {
                ...state.inventario,
                ...state.usuario,
                ...state.item,
                id_usuario: id_usuario,
                id_item: id_item,
            };

            let response;
            if(state.acao === "Criar") {
                response = await method(`/inventario/${state.itemSelecionado.value}/${state.inventario.sec_inventario}`, body);
            } else {
                response =  await method(`/inventario/${state.idItemAntigo}/${state.inventario.sec_inventario}`, body);
            }
            
            if (response.status === 201 || response.status === 200) {
                navigate("/admin/inventarios");
            }  else {
                Swal.fire({
                    title: "Não foi possível salvar o inventario",
                    text: "Erro ao salvar inventario",
                    icon: "error",
                })
            }
        } catch (error) {
            console.error("Erro no salvarInventario():", error);
        }
    }

    const customStyles = {
        control: (provided, state) => ({
            ...provided,
            backgroundColor: '#f8fafc',
            borderColor: state.isFocused ? '#587b7f' : '#e2e8f0',
            borderRadius: '10px',
            minHeight: '40px',
            boxShadow: state.isFocused ? '0 0 0 3px rgba(88, 123, 127, 0.1)' : 'none',
            '&:hover': { borderColor: '#587b7f' }
        }),
        option: (provided, state) => ({
            ...provided,
            backgroundColor: state.isSelected ? '#587b7f' : state.isFocused ? '#f1f5f9' : '#fff',
            color: state.isSelected ? '#fff' : '#334155',
        }),
        singleValue: (provided) => ({ ...provided, color: '#334155' }),
        placeholder: (provided) => ({ ...provided, color: '#cbd5e1' })
    };

    return (
        <div className="admin-page-container">
            {/* Link de Retorno Estilizado */}
            <div className="mb-4">
                <Link to="/admin/inventarios" className="btn-back-modern">
                    <FontAwesomeIcon icon={faAngleLeft} className="me-2" /> Voltar aos Inventários
                </Link>
            </div>

            <Card className="filter-card-admin">
                <Card.Body className="p-4">
                    {/* Título com sotaque visual */}
                    <div className="section-title-modern mb-4">
                        <div className="title-accent"></div>
                        <h2 className="admin-title">{state.acao} Inventário</h2>
                    </div>

                    <Form>
                        <div className="row g-4">
                            <Form.Group className="col-md-6">
                                <Form.Label className="label-admin">Usuário Responsável</Form.Label>
                                <Select 
                                    name="usuarioSelecionado"
                                    onChange={changeUsuario}
                                    isDisabled={state.acao === "Visualizar"}
                                    value={state.usuarioSelecionado}
                                    styles={customStyles}
                                    options={state.opcoesUsuario}
                                    placeholder="Selecione o usuário..."
                                />
                            </Form.Group>

                            <Form.Group className="col-md-6">
                                <Form.Label className="label-admin">Item Inventariado</Form.Label>
                                <Select 
                                    name="itemSelecionado"
                                    onChange={changeItem}
                                    isDisabled={state.acao === "Visualizar"}
                                    value={state.itemSelecionado}
                                    styles={customStyles}
                                    options={state.opcoesItem}
                                    placeholder="Selecione o item..."
                                />
                            </Form.Group>

                            <Form.Group className="col-md-4">
                                <Form.Label className="label-admin">Data da Realização</Form.Label>
                                <Form.Control
                                    type="date"
                                    className="input-moderno"
                                    name="data_inventario"
                                    value={state.inventario.data_inventario ?? ""}
                                    onChange={changeInventario}
                                    disabled={state.acao === "Visualizar"}
                                />
                            </Form.Group>

                            <Form.Group className="col-md-8">
                                <Form.Label className="label-admin">Observações</Form.Label>
                                <Form.Control
                                    as="textarea"
                                    rows={2}
                                    className="input-moderno"
                                    name="observacao"
                                    placeholder="Notas adicionais sobre o estado do item ou localização..."
                                    value={state.inventario.observacao}
                                    onChange={changeInventario}
                                    disabled={state.acao === "Visualizar"}
                                    maxLength={45}
                                />
                            </Form.Group>
                        </div>

                        {state.acao !== "Visualizar" && (
                            <div className="d-flex justify-content-end mt-5 pt-3 border-top">
                                <Button className="btn-apply-filters px-5" onClick={salvarInventario}>
                                    Salvar Inventário
                                </Button>
                            </div>
                        )}
                    </Form>
                </Card.Body>
            </Card>
        </div>
    );
}